'use strict';

var React = require('react');
require('prop-types');
var ObjectHelper = require('../common/ObjectHelper.js');
var Grid = require('../node_modules/@material-ui/core/esm/Grid/Grid.js');
var Button = require('../node_modules/@material-ui/core/esm/Button/Button.js');
var withStyles = require('../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    spacing: {
      marginRight: 16
    }
  };
};

function CancelSaveButtons(_ref) {
  var saveButtonVariant = _ref.saveButtonVariant,
      onCancelClick = _ref.onCancelClick,
      onSaveClick = _ref.onSaveClick,
      isSaving = _ref.isSaving,
      disabled = _ref.disabled,
      classes = _ref.classes;
  return React__default["default"].createElement(Grid["default"], {
    container: true,
    justify: "flex-end"
  }, React__default["default"].createElement(Grid["default"], {
    item: true
  }, React__default["default"].createElement(Button["default"], {
    className: classes.spacing,
    disabled: isSaving,
    onClick: function onClick() {
      if (ObjectHelper.isPresent(onCancelClick)) {
        onCancelClick();
      }
    }
  }, "Cancel")), React__default["default"].createElement(Grid["default"], {
    item: true
  }, React__default["default"].createElement(Button["default"], {
    type: "submit",
    disabled: disabled || isSaving,
    variant: saveButtonVariant,
    color: "primary",
    onClick: function onClick() {
      if (ObjectHelper.isPresent(onSaveClick)) {
        onSaveClick();
      }
    }
  }, isSaving ? 'Saving' : 'Save')));
}

CancelSaveButtons.defaultProps = {
  saveButtonVariant: 'contained',
  isSaving: false,
  disabled: false
};
var CancelSaveButtons$1 = withStyles(styles)(CancelSaveButtons);

module.exports = CancelSaveButtons$1;
